import { useSearchParams } from "react-router-dom";
import { OtpStatsCards } from "./otp-stats-cards";
import { OtpTimeSeriesChart } from "./otp-time-series-chart";
import { OtpChannelChart } from "./otp-channel-chart";

export default function OtpAnalyticsList() {
  const [searchParams] = useSearchParams();

  const startDate = searchParams.get("startDate") || undefined;
  const endDate = searchParams.get("endDate") || undefined;

  return (
    <div className="space-y-6">
      {/* Stats Cards */}
      <OtpStatsCards startDate={startDate} endDate={endDate} />

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <OtpTimeSeriesChart startDate={startDate} endDate={endDate} />
        <OtpChannelChart startDate={startDate} endDate={endDate} />
      </div>
    </div>
  );
}
